import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'makeTopFilter'
})
export class MakeTopFilterPipe implements PipeTransform {

  transform(items: any[], searchText: string, defaultAttribute: string, searchAttribute: string): any[] {
    const filterItemsLimit = 6;
    let filterItems = [];
    if (!items) {
      return filterItems;
    }
    if (!searchText) {
      filterItems = items.filter(item => {
        return item[defaultAttribute].toLowerCase().includes('Y'.toLowerCase());
      });
      // if top doesn't exist, filter first n records
      if (filterItems && filterItems.length) {
        if (filterItems.length >= filterItemsLimit) {
          return filterItems;
        } else { // if (items.length > filterItemsLimit)
          items.forEach(item => {
            if (filterItems.length < filterItemsLimit && !item[defaultAttribute].toLowerCase().includes('Y'.toLowerCase())) {
              filterItems[filterItems.length] = item;
            }
          });
        }
      }
      return filterItems;
    }
    searchText = searchText.toLowerCase();
    return items.filter(item => {
      return item[searchAttribute].toLowerCase().includes(searchText);
    });
  }

}
